import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  MdRefresh,
} from "react-icons/md";
import { Button, Tooltip } from "antd"; // Added Tooltip import
import { useTranslation } from "react-i18next";
import { setFilters } from "../../../../Store/Slices/Admin/staffAttendance/staffAttendance.slice";
import AcademicPeriodPicker from "../../../../Components/Common/AcademicPeriodPicker";
const FilterAttendanceBar = () => {
  const { t } = useTranslation("admClass");
  const { filters } = useSelector((state) => state.admin.staffAttendance);

  const dispatch = useDispatch();


  const handleFilterChange = (name, value) => {
    dispatch(setFilters({ [name]: value }));
  };


  const resetToCurrentMonth = () => {
    const now = new Date();
    dispatch(
      setFilters({
        month: now.getMonth() + 1,
        year: now.getFullYear(),
      })
    );
  };

  return (
    <div className="flex items-center justify-between space-x-4 p-4 rounded-xl bg-white shadow-sm mb-4">
      <div className="flex items-center gap-4">
      </div>

        {/* Month Selector with Reset Button */}
        <div className="flex items-center gap-2">
          <Tooltip title={t("Reset to current month")} placement="top">
            <Button
              icon={<MdRefresh />}
              onClick={resetToCurrentMonth}
              className="flex items-center justify-center"
            />
          </Tooltip>

          <AcademicPeriodPicker
            mode="month"
            value={{ month: filters.month, year: filters.year }}
            onChange={({ month, year }) => {
              dispatch(setFilters({ month, year }));
            }}
          />
        </div>
    </div>
  );
};

export default FilterAttendanceBar;
